import reducer from './reducer.js';
import action from './action';

export {reducer,action};



// WEBPACK FOOTER //
// ./src/entry_app/question_manage/question_evaluating/index.js